<template>
  <div class="msgSet">
    <div class="tip">安全设置</div>
    <MsgItem @updateInfo="updateInfo" :isBind="userInfo.username" :msgType="5" :hint="hint[5]" />
    <MsgItem @updateInfo="updateInfo" :isBind="userInfo.phone" :msgType="1" :hint="hint[1]" :content="userInfo.phone | addStar" />
    <MsgItem @updateInfo="updateInfo" :isBind="userInfo.mail" :msgType="2" :hint="hint[2]" :content="userInfo.mail | addStar('mail')" />
    <MsgItem @updateInfo="updateInfo" :isBind="userInfo.isWechat" :msgType="3" :hint="hint[3]" :content="userInfo.isWechat" />
    <MsgItem @updateInfo="updateInfo" :isBind="userInfo.isPassword" :msgType="4" :hint="hint[4]" />

    <el-button class="logout" round size="small" @click="logout">
      <i class="iconfont icon-tuichuicon"></i>
      退出登录
    </el-button>

    <!-- 绑定/修改邮箱 -->
    <Mail :handlerType.sync="mailHandler" />
    <!-- 绑定/修改邮箱 -->
    <Phone :handlerType.sync="phoneHandler" :userInfo="userInfo" />
    <!-- 设置/修改密码 -->
    <Password :updatePsw.sync="updatePsw" />
    <!-- 绑定微信 -->
    <Weixin :bindWeixin.sync="bindWeixin" />
    <!-- 解除绑定 -->
    <el-dialog title="解除绑定" :visible.sync="relieveBind" width="398px">
      <section class="relieveBind">
        <div class="thirdHeadImg">
          <img :src="host + userInfo.thirdHeadImg" alt="">
        </div>
        <p>解绑后将无法继续使用该微信号快速登录此账号，请谨慎操作！</p>
        <div class="btnBox">
          <el-button plain @click="relieveBind = false" size="medium">取消</el-button>
          <el-button type="primary" @click="reliveve" size="medium">确认解绑</el-button>
        </div>
      </section>
    </el-dialog>
    <!-- 设置账号名 -->
    <Username :updateUsername.sync="updateUsername" :oldUsername="this.userInfo.username"/>
  </div>
</template>

<script>
import MsgItem from "./msgItem.vue"
import Mail from "./bindMail.vue"
import Phone from "./bindPhone.vue"
import Password from "./setPsw.vue"
import Username from "./setUsername.vue"
import Weixin from "./bindWeixin.vue"
import { mapGetters, mapActions } from "vuex";
import { unbingWeixin } from "../../../api/accountManage";
export default {
  components: { MsgItem, Mail, Phone, Password, Weixin, Username },
  props: ['host'],
  data() {
    return {
      hint: {
        1: {
          name: "绑定手机号",
          bind: "绑定手机号将作为您身份验证的重要方式，当前绑定：",
          unbind: "未绑定，绑定手机号将作为您身份验证的重要方式",
          icon: "icon-shoujihao"
        },
        2: {
          name: "绑定邮箱",
          bind: "当前绑定：",
          unbind: "未绑定，绑定增强账户安全",
          icon: "icon-youxiang"
        },
        3: {
          name: "绑定微信公众号",
          bind: "已绑定，绑定的微信账号可用于授权登录爱原物账号。",
          unbind: "未绑定，绑定的微信账号可用于授权登录爱原物账号。",
          icon: "icon-weixin1"
        },
        4: {
          name: "账号密码",
          bind: "已设置，可通过账号密码登录",
          unbind: "未设置，可通过账号密码登录",
          icon: "icon-mima"
        },
        5: {
          name: "账号",
          bind: "账号名称仅作为登录使用，不对外展示",
          unbind: "账号名称仅作为登录使用，不对外展示",
        }
      },
      mailHandler: 0, // 1 绑定邮箱，2 修改邮箱
      phoneHandler: 0, // 1 绑定手机， 2 修改手机
      updatePsw: false, // 修改密码
      bindWeixin: false, // 绑定微信
      isImgVerify: false, // 是否需要图片验证
      relieveBind: false, // 是否显示解除绑定
      updateUsername: false, // 修改用户名
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    ...mapActions(["getUserInfo", "logout"]),
    // 解除绑定
    async reliveve() {
      let res = await unbingWeixin()
      if (res.code === 1) {
        this.getUserInfo()
        this.relieveBind = false
        this.$message({
          type: 'success',
          message: '解除绑定成功'
        })
      }
    },
    // 修改信息
    updateInfo(msgType, type) {
      this.$store.commit("RESET_SMS")
      if (type === 1) { // 修改
        switch (msgType) {
          case 1: // 修改手机号
            this.phoneHandler = 2
            break
          case 2: // 修改邮箱
            this.mailHandler = 2
            break
          case 3: // 解绑微信
            this.relieveBind = true
            break
          case 4: // 修改账号密码
            if (!this.userInfo.mail && !this.userInfo.phone) {
              this.$message({
                type: 'warning',
                message: '请先绑定手机或邮箱'
              })
              return
            }
            this.updatePsw = true
            break
          case 5: // 修改账号名
            this.updateUsername = true
            break
        }
      } else { // 绑定
        switch (msgType) {
          case 1: // 绑定手机号
            this.phoneHandler = 1
            break
          case 2: // 绑定邮箱
            this.mailHandler = 1
            break
          case 3: // 绑定微信
            this.bindWeixin = true
            break
          case 4: // 设置账号密码
            this.updatePsw = true
            break
          case 5: // 修改账号名
            this.updateUsername = true
            break
        }
      }
    },
  }
}
</script>

<style lang="scss">
.msgSet {
  flex: 1;
  height: 100%;
  background: #fff;
  padding: 0 200px;
  .tip {
    font-size: 16px;
    font-weight: 600;
    color: #222222;
    line-height: 18px;
  }
  .dialogContent {
    .hint {
      margin-top: 2px;
      margin-bottom: 26px;
      font-size: 12px;
      color: $gray;
    }
    .el-input {
      input {
        height: 48px;
      }
    }
  }
  .relieveBind {
    padding-bottom: 24px;
    .thirdHeadImg {
      text-align: center;
      margin-top: 40px;
      img {
        width: 86px;
        height: 86px;
        border-radius: 50%;
      }
    }
    p {
      margin-top: 24px;
      margin-bottom: 42px;
      text-align: center;
      padding: 0 20px;
    }
    .btnBox {
      text-align: right;
    }
  }
  .logout {
    color: $primaryColor;
    background: rgba($primaryColor, 0.05);
    border-radius: 4px;
    border: 0;
    font-weight: 400;
    font-family: PingFangSC, PingFang SC;
    font-size: 14px;
    display: block;
    margin: 24px auto 0;
    .iconfont {
      font-size: 12px;
    }
  }
}
</style>